// src/components/cardComponents/dialogComponents/DialogComparisonRow.tsx
import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { styled } from "@mui/system";
import { SlotType } from '../../../types/Slots';
import { useSlotOrDefault } from '../../../hooks/slots/useSlotOrDefault';

const Root = styled(Grid) ({
   display: 'flex',
   flexDirection: 'row',
   justifyContent: 'space-between',
   width: '90%'
})

type DialogComparisonRowProps = React.ComponentPropsWithoutRef<'div'> & {
  label: SlotType;
  value: SlotType;
};

const DialogComparisonRow: FC<DialogComparisonRowProps> = ({
  label,
  value,
  ...rest
}) => {
  const Label = useSlotOrDefault(label, Typography);
  const Value = useSlotOrDefault(value ?? '-', Typography);

  return (
    <Root {...rest}>
      {Label}
      {Value}
    </Root>
  );
};

export { DialogComparisonRow };